/* Fittes quiz analytics (simplified) â€” pushes quiz events to the GTM dataLayer */
window.dataLayer = window.dataLayer || [];
window.FittesQuizTrack = (() => {
  let ctx = {};
  const push = (event, params = {}) => {
    window.dataLayer.push({ quiz: null }); // clear values from the previous push
    window.dataLayer.push({ event, quiz: { ...ctx, ...params } });
  };
  return {
    // quiz_id: 'vent_finder' | 'size_guide'; entry_point: 'menu' | 'pdp' | 'link' | 'direct' | 'handoff'
    start(quiz_id, entry_point) { ctx = { quiz_id, entry_point }; push('quiz_start'); },
    // step_id: 'location' | 'finish' | 'size' | 'airflow' | 'material' | 'results'
    //          'prep' | 'short' | 'long' | 'result' | 'help'
    stepView: (step_id) => push('quiz_step_view', { step_id }),
    // Vent Finder: complete({location:'wall', finish:'flush', size:'4x12', airflow:'plus', material:'luxe'}, 'product-handle')
    // Size Guide:  complete({size:'4x12'}, '4x12')
    complete: (answers, quiz_result) => push('quiz_complete', {
      answer_location: answers.location,
      answer_finish: answers.finish,
      answer_size: answers.size,
      answer_airflow: answers.airflow,
      answer_material: answers.material,
      quiz_result
    }),
    addToCart: (item_name, price) => push('quiz_add_to_cart', {
      item_name, value: price, currency: window.Shopify?.currency?.active
    })
  };
})();